import { useState } from "react";
import "../assets/styles/Cricket.css";
import Menu_select from "../components/Menu_select";
import Menu_Middle from "../components/Menu_Middle";
import Bet_slip from "../components/Bet_slip";
import { useSelector } from "react-redux";
import { newSky } from "../../../AsianExchangeSrc/utils/helper/commonSelectors";

const Soccer = () => {
  const [loading, setLoading] = useState(false);
  const SkyDesign = useSelector(newSky());

  const [gameName] = useState(SkyDesign === "true" ? "Football" : "Soccer");

  const { matches: soccerMatches } = useSelector(
    (state) => state.matches.soccer
  );

  return (
    <>
      <div className="Cricket-wrap">
        <Menu_select menuItems={soccerMatches.data} />
        <Menu_Middle
          cricketMatches={soccerMatches}
          MatchName={gameName}
          loader={loading}
        />
        <Bet_slip />
      </div>
    </>
  );
};

export default Soccer;
